import "./polyfills";
import searchForm from './searchForm';
import tabs from './tabs';
import {initFormValidate, initAntiSpam, addSourcePageToForm, saveFormInfo, addMarketingInfo} from './forms';
import trunk from './trunk.ts';
import fancy from './fancy.ts';
import popup from './popup.ts';
import filterSelector from './filterSelector.ts';
import {showMoreOptions, summery, addOrderInfo, scrollPhotos, addToBasketNotification, putElementFromCard} from './product';
import accordion from './accordion.ts';
import matrikaReachGoals from './matrikaReachGoals.ts';
import headerSearch from './headerSearch.ts';
import {showTime} from './appoinment';
import Datepicker from '../../assets/datepicker/dist/datepicker';
import upBtn from './upBtn.ts';
import {productCounter, changeBasketAmount} from './eMarket';
import headerEmailCopy from './headerEmailCopy.ts';
import {isMobile} from './utils';
import headeerSticky from './headeerSticky.ts';

window.addEventListener('DOMContentLoaded', function(){
	headeerSticky('.header_mob');
	isMobile();
	upBtn();
	headerSearch('.main-menu', '.header__search');
	headerEmailCopy('.header__email__link');

	addToBasketNotification();
	productCounter('.field__amount');
	changeBasketAmount();
	putElementFromCard('.put-btn');
	summery();
	addOrderInfo();
	showMoreOptions();
	scrollPhotos();

	popup([{
        wrapper:' .popup__wrapper',
        action: '.popup__action',
        popup:'.popup'
	}]);
	accordion();

	filterSelector('.filter');

	trunk();
	tabs('examples__nav', 'examples__tabs', {scroll:0});
	searchForm('.header__search-form', '.header__search-icon', '[data-component="header-menu"]', '.header__search-icon-close');


// Формы
	initFormValidate('.form', ['form_search', 'm-form_search', 'filter', 'registrate', 'auth', 'forget']);
	initAntiSpam('.form', ['form_search', 'm-form_search', 'filter', 'registrate', 'auth', 'forget']);
	addSourcePageToForm('input[name = "data[new][source_page]"]');
	saveFormInfo();
	addMarketingInfo();

	const datepicker = new Datepicker('#datepicker', {
		openOn: 'first',
		weekStart: (1),
		yearRange: (1),
		min: (function(){
			var date = new Date();
			date.setDate(date.getDate()+1);
			return date;
		})(),
		i18n: {
			months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
			weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
		},
		onChange: ((Date) => {
			showTime(Date);
		}),
	});
	
	datepicker;
	
	matrikaReachGoals('34175205', [
		// Цель по отправке заказа черех форму в FormValidate.ts
		{target:'.header__icon__phone', goalId: 'PHONE_CLICK', goalEvent: 'click', checkMobile: true},
		{target:'.b-main-phone__link', goalId: 'PHONE_CLICK', goalEvent: 'click', checkMobile: true},
		{target:'.header-second-phone', goalId: 'PHONE_CLICK', goalEvent: 'click', checkMobile: true},
		{target:'.footer-second-phone', goalId: 'PHONE_CLICK', goalEvent: 'click', checkMobile: true},
		{target:'.header__email__link', goalId: 'EMAIL_CLICK', goalEvent: 'click'},
		{target:'.header__whatsapp__link', goalId: 'WHATSAPP_CLICK', goalEvent: 'click'},
	]);

	// Fancy
	const selectors = [
		{trigger: 'order_form', form: 'order_form', header: 'Заказать'},
		{trigger: 'order_parts_form', form: 'order_parts_form', header: 'Заказать'},
		{trigger: 'callback_form', form: 'callback_form', header: 'Заказать обратный звонок'},
	];
	fancy(selectors);

});